<template>
  <SAIMessage variant="negative">
    <slot>
      Please complete the mandatory fields highlighted in red below.
    </slot>
  </SAIMessage>
</template>

<script>
export default {
  name: 'SAIFormError',
  components: {
    SAIMessage: () => import('../sai-message')
  }
};
</script>
